import {
  translateLabels,
} from '../components/Translate';

import {
  isWideTablet,
  isWideMobile,
  urlGet,
  isMobilePhone,
  centerXFanchart,
  centerYFanchart,
} from './calc';


import { data } from '../version/dataVersion.js';

export const eth0AtSeinfeld = '192.168.56.102'; // Static. Does not change
//export const eth0AtSeinfeld = '10.27.145.148'; // Dynamically changes
// export const eth0AtSeinfeld = '192.168.2.173'; // Candada

export const prodScript = document.getElementById('prodScript');  // script tag on production server
let localhost = `http://${eth0AtSeinfeld}:5000`;
export const host = prodScript && !prodScript.getAttribute('host').match(/:5000$/) ? prodScript.getAttribute('host') : localhost;

   console.log(`%c REACT-18-TREE`, [
     'color: white',
     'background: blue',
     'font-size: 14px',
     'border: 5px solid red',
     'padding: 10px',
     ].join(';'));

/*

  Local host on mobile devices and desktop:

  http://192.168 .< from  >:3000/13038  Look at macbook IP address
  http://192.168.0.14:3000/769971

  Reach Seinfeld to Login using Chrome Browser:

  http://192.168.< eth0 >:5000
  i.e.:  http://192.168.0.71:5000

 */

export const isSeinfeld = prodScript && host.match(/:5000$/);
export const isStage = prodScript && host  === '//stage.geni.com'

export const version    = data.version;
export const gitMessage = data.gitMessage;
export const dateCommit       = data.date;

export const minimal    = ( prodScript && prodScript.getAttribute('minimal') ?  true : false);
export const no_decoration    = ( prodScript && prodScript.getAttribute('no_decoration') ?  true : false);

// export const minimal       = false;
export const resolveId  = ( prodScript ? prodScript.getAttribute('resolveId') : '');
export const rtl  = ( prodScript ? prodScript.getAttribute('rtl') : false);
export const isRtl = (rtl === '1' || urlGet('rtl') === "true"? true: false);
// export const isRtl = true;
export const showPrintTree  = ( prodScript ? prodScript.getAttribute('showPrintTree') : '');
export let importCustomStylesFromServer  = ( prodScript ? prodScript.getAttribute('styles') : undefined);
if (urlGet('noStyles') === "true") importCustomStylesFromServer = undefined;
// export const importCustomStylesFromServer  = JSON.stringify({"1":{"hasCus":false,"selectedtheme":"newsprint","fontSizeChoice":"large","custom":{"maleCustomPresetColor":"#A9CFE7","femaleCustomPresetColor":"#F6B8DB","unGenderedCustomPresetColor":"#C8F176","stageBackgroundCustomPresetColor":"#EEF0DD"}}});
// console.log(`importCustomStylesFromServer: `, importCustomStylesFromServer);
// console.log(`importCustomStylesFromServer: `, JSON.stringify(importCustomStylesFromServer, null, 2));

/*
  importCustomStylesFromServer  = JSON.stringify({
    "1": {
      "selectedtheme": "primary",
      "fontSizeChoice": "large",
      "custom": {
        "maleCustomPresetColor": "#A9CFE7",
        "femaleCustomPresetColor": "#F6B8DB",
        "unGenderedCustomPresetColor": "#C8F176",
        "stageBackgroundCustomPresetColor": "#EEF0DD"
      },
      "options": {
        // "showCardPhotos": true,
        "showCardEditIcon": true,
        "showCardEmailInvite": true
      }
    }
  });
*/
export const treeSessionId  = ( prodScript ? prodScript.getAttribute('treeSessionId') : '');
export const subroot    = ( prodScript ? prodScript.getAttribute('subroot') : '');
export const dualPedigreeLaunchByURL  = ( urlGet('dualPedigreeLaunch') === "true" ? true: false );
export const isPedigreeByURL  = ( urlGet('isPedigree') === "true" ? true: false );
let isDualPedigreeMode = ( prodScript && prodScript.getAttribute('dualPedigree') ? prodScript.getAttribute('dualPedigree') : dualPedigreeLaunchByURL || '');
isDualPedigreeMode = ( isDualPedigreeMode === '1' ? true: dualPedigreeLaunchByURL);
export const dualPedigreeMode  = isDualPedigreeMode;
export const isDevelopment = ( prodScript ? false : true);

// console.log(`isDevelopment: `, isDevelopment);

/* DEBUG */
export const debugWiderCatchForFetchProfiles                          = ( urlGet('debugWiderCatch') === "true" ? true: false );
export const debugFetchPrunes                                         = ( urlGet('debugFetchPrunes') === "true" ? true: false );
export const debugCallbackFetchResolveAndPopModal                     = ( urlGet('debugCallbackFetchResolveAndPopModal') === "true" ? true: false );
export const autoFetchProfiles                                        = false;
export const debugDiv                                                 = false;
export const debug                                                    = ( urlGet('debug') === "true" ? true: false );;
export const debugLocationHistory                                     = false;

export const maxIdsPerRequest = ( urlGet('maxIdsPerRequest') ?  urlGet('maxIdsPerRequest') : isDevelopment ? undefined: prodScript.getAttribute('maxIdsPerRequest'));
export const maxConcurrentRequests = ( urlGet('maxConcurrentRequests') ?  urlGet('maxConcurrentRequests') :  isDevelopment ? undefined: prodScript.getAttribute('maxConcurrentRequests'));


/* MOBILE */
export const autoLaunchflipcard                                       = false;
export const autoLaunchMoreMobile                                     = false;
export const autoLaunchNavGotoListMobile                              = false;
export const autoLaunchLegendListMobile                               = false;
export const autoLaunchPrintCardMobile                                = false;
export const autoLaunchflipcardThenAddPanel                           = false;
export const autoLaunchflipcardThenMoreForm                           = false;
export const autoLaunchflipcardThenAddPanelThenSlideUpImmediateFamily = false;
export const autoLaunchflipcardThenAddPanelThenSlideUpAddSourceCitation = false;
export const autoClickPrintTreeMobileIcon                             = false;

/* DESKTOP */
export const autoLaunchflippanel                                      = false;
export const autoFlipnode                                             = undefined;
export const autoLaunchflippanelThenClickRoone                        = false;
export const autoClickNavigationNow                                   = false;
export const dualPedigreeLaunchOnDev                                  = ( (urlGet('dualPedigreeLaunch') === "true" && isDevelopment) || (urlGet('dualPedigreeLaunch') === "true" && isSeinfeld) ? true: false );
export const autoClickPrintTreeIcon                                   = false;
export const autoClickPreferences                                     = false;
export const autoLaunchDualPedigreeModal                                      = false;
export const cachetree                                                = ( urlGet('cachetree') === "true" ? true: false );;

export const autoClickProductTourIcon                                 = false;
export const hasExpiringProUpsell                                     = document.getElementById("expiring_pro_upsell") ? true: false;
export const hasTreeActivationBanner                                  = document.getElementById("tree_activation_banner") ? true: false;
export const hasActive_notice                                         = /*!isMobilePhone() && */document.getElementById("active_notice") && document.getElementById("static_notice") && document.querySelector('.message_content').style.display !== 'none' ? true: false;

/* PEDIGREE */
export const autoLaunchPedigreeCallout                                = (urlGet('import') === "true" ? false: false);
export const seePedigreeAddboxConsoleLog                              = (urlGet('import') === "true" ? false: false);

/* FORCEFANCHART */
export const forceFanChart                             = (urlGet('forceFanChart') === "true" ? true: false);
export const defaultFanChartStagePos = {
                                          x: centerXFanchart(),
                                          y: centerYFanchart(),
                                        };

/*
 * Fetches
 */
const prunesChunksize = 99999999999999;
export const fetchPrunesChunkLength                                   = (urlGet('changePrunesChunkLength') === "true" ? urlGet('prunesChunks'): prunesChunksize);
export const fetchPrunesDelay                                         = 4000;
export const timeTillResetRequestedFetchPrunesNodeIds                 = 10000;

/*
 * Tree Constants
 */

export const FETCH_SOMETHING                  = 'Tree/FETCH_SOMETHING';
export const SET_SOMETHING                    = 'Tree/SET_SOMETHING';
export const FETCH_TREE                       = 'Tree/FETCH_TREE';
export const SET_RESOLVE                      = 'Tree/SET_RESOLVE';
export const POST_RESOLVE                     = 'Tree/POST_RESOLVE';
export const FETCH_IMMEDIATE_FAMILY           = 'Tree/FETCH_IMMEDIATE_FAMILY';
export const FETCH_LEGEND_DESCRIPTIONS           = 'Tree/FETCH_LEGEND_DESCRIPTIONS';
export const FETCH_MORE                       = 'Tree/FETCH_MORE';
export const FETCH_PRUNES                     = 'Tree/FETCH_PRUNES';
export const FETCH_PROFILES                   = 'Tree/FETCH_PROFILES';
export const FLUSHALLCALLBACKFORFETCHPROFILES = 'Tree/FLUSHALLCALLBACKFORFETCHPROFILES';
export const RELEASEQUEUEFETCHEDPROFILESDATA  = 'Tree/RELEASEQUEUEFETCHEDPROFILESDATA';
export const RELEASEQUEUEOFFETCHEDNODEOBJPICS = 'Tree/RELEASEQUEUEOFFETCHEDNODEOBJPICS';
export const NOTIFYPROFILEADD           = 'Tree/NOTIFYPROFILEADD';
export const UPDATEMATCHCOUNTS           = 'Tree/UPDATEMATCHCOUNTS';
export const CHECKQUEUEFETCHEDNODEOBJPIC      = 'Tree/CHECKQUEUEFETCHEDNODEOBJPIC';
export const FETCH_FLIPDATA                   = 'Tree/FETCH_FLIPDATA';
export const UNSET_FLIPDATA                   = 'Tree/UNSET_FLIPDATA';
export const UNSET_NODEOBJ_PROP               = 'Tree/UNSET_NODEOBJ_PROP';
export const UNSET_NODEOBJ_PIC                = 'Tree/UNSET_NODEOBJ_PIC';
export const UNSET_NODEOBJ_GEDCOM             = 'Tree/UNSET_NODEOBJ_GEDCOM';
export const SET_NODEOBJ_PIC                  = 'Tree/SET_NODEOBJ_PIC';
export const STORE_CUSTOM_RECENTER_IN_DUALPEDIGREE                  = 'Tree/STORE_CUSTOM_RECENTER_IN_DUALPEDIGREE';
export const DESIGNATE_DROPTARGET             = 'Tree/DESIGNATE_DROPTARGET';
export const UNDESIGNATE_DROPTARGET           = 'Tree/UNDESIGNATE_DROPTARGET';
export const FETCH_TREE_ERROR                 = 'Tree/FETCH_TREE_ERROR';
export const POST_INVITE                      = 'Tree/POST_INVITE';
export const FETCH_PREFERENCES                = 'Tree/FETCH_PREFERENCES';
export const POST_PREFERENCES                 = 'Tree/POST_PREFERENCES';
export const POST_POSTER                      = 'Tree/POST_POSTER';
export const GETUNION_ID_FANCHART             = 'Tree/GETUNION_ID_FANCHART';
export const UPLOADPHOTO                      = 'Tree/UPLOADPHOTO';
export const POSTREDUX_PREFERENCES            = 'Tree/POSTREDUX_PREFERENCES';
export const POST_PREFERENCESCHARTTYPE        = 'Tree/POST_PREFERENCESCHARTTYPE';
export const POST_CHOSENUNIONID               = 'Tree/POST_CHOSENUNIONID';
export const ADD_FLOATER                      = 'Tree/ADD_FLOATER';
export const REMOVE_FLOATER                   = 'Tree/REMOVE_FLOATER';
export const POST_ADD_EXISTING                = 'Tree/POST_ADD_EXISTING';
export const SET_UNIONS                       = 'Tree/SET_UNIONS';
export const SET_BRANCHES                     = 'Tree/SET_BRANCHES';
export const SET_PRID                         = 'Tree/SET_PRID';
export const SET_NODES_OBJS                   = 'Tree/SET_NODES_OBJS';
export const SET_FAN_CHART_DATA               = 'Tree/SET_FAN_CHART_DATA';
export const SET_FANCHART_UNIQUE_CHARS        = 'Tree/SET_FANCHART_UNIQUE_CHARS';
export const SET_WIDTHS_NAMES_FOR_FANCHART        = 'Tree/SET_WIDTHS_NAMES_FOR_FANCHART';
export const SET_IS_LARGETREE                 = 'Tree/SET_IS_LARGETREE';
export const SET_TEST                         = 'Tree/SET_TEST';
export const SET_NODES_OBJS_BY_NODE           = 'Tree/SET_NODES_OBJS_BY_NODE';
export const SET_NODEOBJSBYRANGE              = 'Tree/SET_NODEOBJSBYRANGE';
export const SET_COUNTOF                      = 'Tree/SET_COUNTOF';
export const SET_CANVAS_HEIGHT_TOP            = 'Tree/SET_CANVAS_HEIGHT_TOP';
export const SET_EDGES                        = 'Tree/SET_EDGES';
export const SET_FOCUSNODE                    = 'Tree/SET_FOCUSNODE';
export const SET_CID_GRPS                      = 'Tree/SET_CID_GRPS';
export const SET_FIRSTTREEMATCHCOUNTNODE      = 'Tree/SET_FIRSTTREEMATCHCOUNTNODE';
export const SET_FIRSTRECORDMATCHCOUNTNODE    = 'Tree/SET_FIRSTRECORDMATCHCOUNTNODE';
export const SET_FIRSTMALEGHOSTNODE           = 'Tree/SET_FIRSTMALEGHOSTNODE';
export const SET_FIRSTFEMALEGHOSTNODE           = 'Tree/SET_FIRSTFEMALEGHOSTNODE';
export const SET_FIRSTTREEMATCHNODE           = 'Tree/SET_FIRSTTREEMATCHNODE';
export const SET_FIRSTDEADNODE           = 'Tree/SET_FIRSTDEADNODE';
export const SET_FIRSTRECORDMATCHNODE           = 'Tree/SET_FIRSTRECORDMATCHNODE';
export const SET_FIRSTSMARTMATCHNODE           = 'Tree/SET_FIRSTSMARTMATCHNODE';
export const SET_FIRSTCYCLEMASTERNODE        = 'Tree/SET_FIRSTCYCLEMASTERNODE';
export const SET_FIRSTMULTIPLEPARENTNODE     = 'Tree/SET_FIRSTMULTIPLEPARENTNODE';

export const FIRSTEDITNODE     = 'Tree/FIRSTEDITNODE';
export const FIRSTEMAILREQUESTNODE     = 'Tree/FIRSTEMAILREQUESTNODE';
export const SET_FIRSTINCONSISTENTENCYNODE     = 'Tree/SET_FIRSTINCONSISTENTENCYNODE';
export const SET_FIRSTMERGEPENDINGNODE     = 'Tree/SET_FIRSTMERGEPENDINGNODE';
export const SET_FIRSTAPPEAR05NODE     = 'Tree/SET_FIRSTAPPEAR05NODE';
export const SET_FIRSTAPPEAR06NODE     = 'Tree/SET_FIRSTAPPEAR06NODE';
export const SET_FIRSTAPPEAR07NODE     = 'Tree/SET_FIRSTAPPEAR07NODE';
export const SET_FIRSTAPPEAR08NODE     = 'Tree/SET_FIRSTAPPEAR08NODE';
export const SET_FIRSTAPPEAR09NODE     = 'Tree/SET_FIRSTAPPEAR09NODE';
export const SET_NUMOFGENERATIONS     = 'Tree/SET_NUMOFGENERATIONS';

export const SET_FIRSTCONFLICTNODE           = 'Tree/SET_FIRSTCONFLICTNODE';
export const SET_FIRSTDNANODE                = 'Tree/SET_FIRSTDNANODE';




export const SET_LOOKUPNODEID                 = 'Tree/SET_LOOKUPNODEID';
export const SET_LOOKUPPRID                   = 'Tree/SET_LOOKUPPRID';
export const SET_PROFILE_OBJS                 = 'Tree/SET_PROFILE_OBJS';
export const SET_VIEWPORT                     = 'Tree/SET_VIEWPORT';
export const SET_PROGRESS                     = 'Tree/SET_PROGRESS';
export const SET_CANVAS_WIDTH                 = 'Tree/SET_CANVAS_WIDTH';
export const SET_CANVAS_HEIGHT                = 'Tree/SET_CANVAS_HEIGHT';
export const SET_FLIPDATA                     = 'Tree/SET_FLIPDATA';
export const SET_PREFERENCES                  = 'Tree/SET_PREFERENCES';
export const SET_FLOATERS                     = 'Tree/SET_FLOATERS';
export const SET_LEGEND_DESCRIPTIONS           = 'Tree/SET_LEGEND_DESCRIPTIONS';
// export const SET_DROPON_NODE               = 'Tree/SET_DROPON_NODE';
export const FETCH_FLOATERS                   = 'Tree/FETCH_FLOATERS';
export const STOP_INFLIGHT_SAGAS              = 'Tree/STOP_INFLIGHT_SAGAS';
export const CANCEL_SPAWNED_FETCHPROFILES    = 'Tree/CANCEL_SPAWNED_FETCHPROFILES';


/*
 *
 *
 * Geni Outer Frame Components
 *
 *
 */

export const footerHeight = 36;
export const tabletFooterHeight = 36;
export const defaultCanvasTop = 63;
export const heightOfPublicBottomBannerForUnSignedInUser = 0;

/*
 *
 *
 * Canvas
 *
 *
 */

let adaptTopDevelopmentLocalHost = ( hasTreeActivationBanner || hasExpiringProUpsell ? 103: 67);
export const canvasTopDevelopmentLocalHost = ( hasActive_notice ? adaptTopDevelopmentLocalHost  - 32 : adaptTopDevelopmentLocalHost);

export const initialCanvasTopDesktopMargin = 65;
export const treeActivationBannerHeight    = 38;
export const activeNoticeBannerHeight      = 32;
export const canvasSideMargin              = 0;
export const canvasPadding                 = 10;
export const canvasBottomMargin            = 30;
export const viewPortBuffer                = ( window.innerWidth / 4 > 100 ? 100 : window.innerWidth / 4 );  // side buffer zone outside stage viewport of where node and lines are redrawn

export const widthScale                    = 15;
export const heightScale                   = 13;

export const flipPanelWidth                = 370;
export const mouseoverBoxWidth             = 50;
export const mouseoverBoxHeight            = 50;
export const scaleDownDesktopIcon          = '.8';



export const largeTreeNodeThreshold        = 500;
export const rangeKeyIncrement             = 500;
// export const largeTreeRangeKeyIncrement = 300;
export const largeTreeRangeKeyIncrement    = 400;
// export const largeTreeMaxViewportWidth  = 400;
export const largeTreeMaxViewportWidth     = 600;

// export const scalePrintCanvas              = 3;
// export const scalePrintCanvas              = 1.8;  // printTreeResolution SuperTweak old: 3

/*
 *
 *
 * FLIPPANEL
 *
 *
 */

export const heightOfInformationBox    = 0;
/*
 *
 *
 * Nodes and Unions
 *
 *
 */

export const nodeWidth                       = 70;
export const nodeHeight                      = 30;
export const pedigreeIsTallNodeHeight        = 21;
export const pedigreeNodeHeight              = 15;
export const widthOfPedigreeCallOutBox       = 320;
export const triTipWidthOfPedigreeCallOutBox = 35;
export const picDim                          = 26;
export const pedigreeIsTallPicDim            = 18;
export const pedigreePicDim                  = 12;
export const distanceBetweenNodes            = 20;
// export const maleDefaultColor                       = 'lightblue';
export const maleDefaultColor                       = '#A9CFE7';
export const maleDefaultHSVColor                    = {h:203,s:27,v:91};
export const maleDefaultColorLight                  = '#CFE8F0';
// export const femaleDefaultColor                     = 'pink';
export const femaleDefaultColor                     = '#F6B8DB';
export const femaleDefaultHSVColor                    = {h:326,s:25,v:96};
export const femaleDefaultColorLight                = '#FFD8DE';
export const unGenderedDefaultColor                 = '#C8F176';
export const unGenderedDefaultHSVColor              = {h:80,s:29,v:97};
export const unGenderedDefaultColorLight            = '#DFF7B0';
export const stageBackgroundDefaultColor            = '#EEF0DD';
export const stageBackgroundDefaultHSVColor         = {h:66,s:8,v:94};
export const privateColor                    = '#D3D3D3';
export const focusColor                      = '#FDFDFD';
export const relatedColor                    = '#000000';
export const unrelatedColor                  = '#9C9C97';
export const exStockColors = [
  'gray', 'blue', 'brown', 'orange', 'purple', 'green', 'darkblue', 'red', 'darkgray', 'olive', 'lightblue'
];
export const lineCap           = 'block'; // components/Line   what the caps for the lines look like... could be round
export const strokeWidth       = (dualPedigreeMode ? 1: .5);
export const miniMapStrokeWidth= 1;
export const cornerBuffer      = .25;
export const borderColor       = '#d1d1ca';
export const textareaFontColor = '#464646';
export const claimedColor = '#51B4ED';
export const masterProfileColor = 'purple';
export const puplicProfileColor = '#79CE03';


/*
 *
 *
 *
 *  Mobile Devices
 *
 */


export const androidTabletBottomBar = 36;
export const sliderTopBar = 56;
export const iphoneBottomBar = 55;
export const bottomSaveBarForMobileSourceCitation = 200;
export const mobileButtonDim = 34;

/*
 *
 *
 *
 *  Preferences
 *
 */

export const modalPreferencesSubLabelFontSize  =  16;
export const modalPreferencesFontSize  =  14;

/*
 *
 *
 *
 *  Move
 *
 */

export const fontColor = '#636363';
export const fontSize  = '16px';

/*
 *
 *
 *
 *  FullName
 *
 */

  export const fullNameFontColor             = '#000000';
  export const fullNameFontStyle             = 'normal';
  export const fullNameFontWeight             = 'normal';
  export const fullNameLineWidthDefaultTreeNormalFont  = 40;
  export const fullNameLineWidthDefaultTreeLargeFont  = 32;
  export const fullNameLineWidthPedigreeTreeNormalFont = 50;
  export const fullNameLineWidthDualPedigreeTreeNormalFont = 47;
  export const fullNameLineWidthPedigreeTreeLargeFont  = 36;

  export const fullNameFontSize              = 4.8;
  export const fullNameLargeFontSize         = 6;
  export const fullNameLineHeight            = 1.2;
  export const fullNameLargeFontLineHeight   = .6;

  // export const fullNameFontSize              = 6; // 4.8;
  //  export const fullNameLineHeight            = 1.3

  // const usesOpenSans = ()=>{
  //   return isChrome() || isFireFox() || isAndroidPhone() || isIE();
  // }
  // export const fontFamily                    = ( usesOpenSans() ? 'Open Sans' : 'Helvetica');

  // export const fontFamily                    = 'Open Sans';
  //export const fontFamily = 'Helvetica';
  // export const fontFamily = 'Source Sans Pro';
   export const fontFamily = 'Open Sans';


/*
  Also need to add....
  <link href="https://fonts.googleapis.com/icon?family=Open+Sans|Source+Sans+Pro|Material+Icons" rel="stylesheet">

 */

// export const widthBetweenAdjacentPartners = 72;  // components/T depreciated
export const handleHeight = 8;
export const goalPostHeight = 8;
export const raiseHandleBy = 4;

export const matchesColors = {
  tree  : '#1D96E0',
  record:'#E0AC62',
  smart :'#83C162',
  empty : '#C1C3C5',
}

export const oneGenerationVerticalDistance = 52;
export const editTreeActionIconTop = 24;
export const editTreeActionOpacity = .4;


export const shiftNodeUpForFlipCard = 39;
export const flipCardTop = 168;
export const flipCardPaddingBottom = 20;

export const smallestMobileCanvasWidth = 320;

/*
 *
 *
 * Navigation
 *
 *
 */

export const navigationHeight = 243;
export const navigationBottom = -154;
export const moveNavPercentUp = 2.9;
export const navigationTabContentStretchedWrapperHeight = 173;
export const navigationTabContentStretchedWrapperHeightPaddingTop = 30;
export const firstCountNodeShiftX = 300;
export const firstCountOrWarningNodeShiftY = 140

/*
 *
 *
 * Print
 *
 *
 */

export let imgPrinterIconHash = {
     'fan' : 'fanchartBorder',
     'default' : 'defaulttree',
     'horizontal' : 'pedigreetree',
    }

/*
 *
 *
 * Fan Chart
 *
 *
 */

    export const minScreenWidthFanchart = 890;

/*
 *
 *
 * Dual Pedigree
 *
 *
 */
    export const defaultDualPedigreeTitleBorder =  'border1.svg';
    export const defaultDualPedigreeFontFamily =  'Open Sans';
    export const defaultDualPedigreeHighlightColor =  '#EFEFEF';

    export const defaultPercentOfZoomLevelForDualPedigree = .05;
    export const defaultZoomLevelValueForDualPedigree = 43;
    export const defaultDualPedigreeFrameStyle = 'fancy';

    export const widenDualPedigreeBranchesBy = 20;
    export const spanOutDualPedigreeProfilessBy = 40;
    export const defaultBackgroundTextureFileName =  'tree_background';
    export const dualPedigreeFlipPanelWidth = 225;
    export const stageDualPedigreeSizeObj = {
      width: 717,
      height: 511,
      offsetX: 28,
      offsetY: 40,
    }

    export const stagePedigreeSizeObj = {
      width: 717  * 1.2,
      height: 511  * 1.2,
    }

    export const stagePrintDualPedigreeSizeObj = {
      width: 7200,
      height: 4800,
      printShiftX: 170,
      printShiftY: 220,
    }
    export const stagePrintPedigreeFanchartSizeObj = {
      width: 7200 /  1.2,
      height: 4800 /  1.2,
    }

    export const sideFrameLength = 65;

    const background_poster_multiply = 1/4;
    const background_poster_shift = 0;

    export const dualPedigreeBackgroundHash =  {
      'tree_background': {
        ext: 'jpg',
        repeat: 'no-repeat',
        scale: background_poster_multiply,
        offsetX: (stageDualPedigreeSizeObj.offsetX / background_poster_multiply) + (background_poster_shift / background_poster_multiply),
        offsetY: stageDualPedigreeSizeObj.offsetY / background_poster_multiply,
        width: (stageDualPedigreeSizeObj.width / background_poster_multiply) + (background_poster_shift / background_poster_multiply),
        height: stageDualPedigreeSizeObj.height / background_poster_multiply,
      },
      'houndstooth': {
        ext: 'png',
        repeat: 'repeat',
        size: 'cover',
        scale: 1,
        offsetX: stageDualPedigreeSizeObj.offsetX,
        offsetY: stageDualPedigreeSizeObj.offsetY,
        width: stageDualPedigreeSizeObj.width,
        height: stageDualPedigreeSizeObj.height,
      },
      'pinstripe': {
        ext: 'png',
        repeat: 'repeat',
        size: 'cover',
        scale: 1,
        offsetX: stageDualPedigreeSizeObj.offsetX,
        offsetY: stageDualPedigreeSizeObj.offsetY,
        width: stageDualPedigreeSizeObj.width,
        height: stageDualPedigreeSizeObj.height,
      },
      'squares': {
        ext: 'png',
        repeat: 'repeat',
        size: 'cover',
        scale: 1,
        offsetX: stageDualPedigreeSizeObj.offsetX,
        offsetY: stageDualPedigreeSizeObj.offsetY,
        width: stageDualPedigreeSizeObj.width,
        height: stageDualPedigreeSizeObj.height,
      },
      'stripes': {
        ext: 'png',
        repeat: 'repeat',
        size: 'cover',
        scale: 1,
        offsetX: stageDualPedigreeSizeObj.offsetX,
        offsetY: stageDualPedigreeSizeObj.offsetY,
        width: stageDualPedigreeSizeObj.width,
        height: stageDualPedigreeSizeObj.height,
      },
    }



    export let dimDualPedigreeSVGFrames = {
          'fancy': {
              profile:{
                innerFrameSideLength: 460,
                innerFrameSideDown: -20,
                innerFrameSideRight: -50,
              },
                placeholder:{
                  innerFrameSideLength: 760,
                  innerFrameSideDown: -5,
                  innerFrameSideRight: 0,
                }
          },
          'ellipse': {
              profile:{
                innerFrameSideLength: 460,
                innerFrameSideDown: -20,
                innerFrameSideRight: -50,
              },
                  placeholder:{
                    innerFrameSideLength: 920,
                    innerFrameSideDown: 0,
                    innerFrameSideRight: -10,
                  }
          },
          'circle': {
              profile:{
                innerFrameSideLength: 460,
                innerFrameSideDown: -20,
                innerFrameSideRight: -50,
              },
                  placeholder:{
                    innerFrameSideLength: 850,
                    innerFrameSideDown: 10,
                    innerFrameSideRight: 10,
                  }
          },
          'square': {
              profile:{
                innerFrameSideLength: 460,
                innerFrameSideDown: -20,
                innerFrameSideRight: -50,
              },
                  placeholder:{
                    innerFrameSideLength: 905,
                    innerFrameSideDown: 2,
                    innerFrameSideRight: 2,
                  }
          },
          'cross': {
              profile:{
                innerFrameSideLength: 460,
                innerFrameSideDown: -20,
                innerFrameSideRight: -50,
              },
                  placeholder:{
                    innerFrameSideLength: 850,
                    innerFrameSideDown: 10,
                    innerFrameSideRight: 10,
                  }
          },
        };

  export const framesArray = [
      {name: 'fancy', svg: 'fancy'},
      {name: 'ellipse', svg: 'elipse'},
      {name: 'circle', svg: 'circle'},
      {name: 'square', svg: 'square'},
      {name: 'cross', svg: 'cross'},
  ];


  export const titleBorderArray = [
    {name: 'border 1', filename: 'border1',}, //https://www.shutterstock.com/image-vector/vector-border-title-invitation-1662573232
    {name: 'border 4', filename: 'border4',}, //https://www.shutterstock.com/image-vector/vector-border-title-invitation-1662573232
    {name: 'border 5', filename: 'border5',}, //https://www.shutterstock.com/image-vector/vector-border-title-invitation-1662573232
    {name: 'border 6', filename: 'border6',}, //https://www.shutterstock.com/image-vector/vector-border-title-invitation-1662573232
    {name: 'border 7', filename: 'border7',}, //https://www.shutterstock.com/image-vector/vector-border-title-invitation-1662573232
    {name: 'border 7', filename: '', none: true},
  ];

  /*
  <script src="https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js"></script>
   */
  export const fontArray = [
      {name: 'Andada Pro', width: 47},
      // {name: 'Anton'},
      // {name: 'Archivo'},
      {name: 'BioRhyme', width: 36},
      // {name: 'Century Expanded'},
      // {name: 'Cormorant Garamond'},
      // {name: 'Encode Sans'},
      // {name: 'Epilogue'},
      // {name: 'Futura'},
      {name: 'Hahmlet', width: 40},
      // {name: 'Inter'},
      {name: 'JetBrains Mono', width: 36},
      // {name: 'Lora'},
      // {name: 'Lobster'},
      // {name: 'Manrope'},
      {name: 'Montserrat', width: 40},
      // {name: 'Nunito'},
      {name: 'Open Sans', width: 47},
      // {name: 'Oswald'},
      {name: 'Playfair Display', width: 47},
      {name: 'Raleway', width: 45},
      // {name: 'Roboto'},
      // {name: 'Sora'},
      // {name: 'Times Roman'},
    ];

/*
 *
 *
 * Color themes
 *
 *
 */

export const presetObj = {
  default:{
    trl: true,
    malePresetColor: maleDefaultColor,
    femalePresetColor: femaleDefaultColor,
    unGenderedPresetColor: unGenderedDefaultColor,
    stageBackgroundPresetColor: stageBackgroundDefaultColor
  },
  flashy: {
    malePresetColor: "#a9d0e6",
    femalePresetColor: "#ffcafa",
    unGenderedPresetColor: "#c5f06f",
    stageBackgroundPresetColor: "#eef0dd"
  },
  mahogany: {
    malePresetColor: "#7bb5e5",
    femalePresetColor: "#cb6084",
    unGenderedPresetColor: "#a6b892",
    stageBackgroundPresetColor: "#c5c3ac"
  },
  newsprint: {
    malePresetColor: "#6b6b6b",
    femalePresetColor: "#ffffff",
    unGenderedPresetColor: "#dfdfdc",
    stageBackgroundPresetColor: "#a9a9a9"
  },
  primary: {
    malePresetColor: "#2196f3",
    femalePresetColor: "#e91e63",
    unGenderedPresetColor: "#8bc34a",
    stageBackgroundPresetColor: "#ebebe8"
  },
  night: {
    malePresetColor: "#03a9f4",
    femalePresetColor: "#d8a1b4",
    unGenderedPresetColor: "#b2cb93",
    stageBackgroundPresetColor: "#000000"
  }
}
/*
 *
 *
 * SlideUpImmediate Family
 *
 *
 */

export const slideUpImmediateHeight = 545;
export const slideUpImmediateBottom = -277;
export const slideUpImmediateMoveNavPercentUp = 2.5;

/*
 *
 *
 * SlideUpAddSourceCitation
 *
 *
 */

// export const slideUpAddSourceCitationHeight = 620;
// export const slideUpAddSourceCitationBottom = -245;
// export const slideUpAddSourceCitationMoveNavPercentUp = 2.1;

export const slideUpAddSourceCitationHeight = window.innerHeight - ( window.innerHeight / 3.4) + (window.innerHeight *  .12);
export const slideUpAddSourceCitationBottom = -1 * (window.innerHeight / 3.0);
export const slideUpAddSourceCitationMoveNavPercentUp = 2.0;

/*
 *
 *
 * Animations
 *
 *
 */

export const timeDelayForInviteIsSent              = 2000
export const minMilisec4TouchHold                  = 500
export const numOfStepsOnAnimatedPan               = 5
export const panSpeedInMilisecs                    = 20;
export const pauseMillisecB4Zoom                   = 10;
export const scaledChangeInDist4KeyPress           = 70;
export const changeInTime4KeyPress                 = 200;

export const numberOfZoomSteps                     = 5;
export const zoomSpeedInMilisecs                   = 20;
export const minZoom                               = .5
export const maxZoom                               = 5;
export const scaleForMinimalComponents             = 1.1;
export const targetFocusMobileScale                = 2.3;

export const targetFocusPedigreeIpadScale          = ( isWideTablet ? 2.16: 2.16);
// export const targetFocusPedigreeMobilePhoneScale   = ( isWideMobile ? 3: 3);
export const targetFocusPedigreeIpadCenterX        = ( isWideTablet ? -60: -140); //dev
export const targetFocusPedigreeIpadCenterY        = ( isWideTablet ? -50: 40); //dev
export const targetFocusPedigreeMobilePhoneCenterX = ( isWideMobile ? -60: -150);
export const targetFocusPedigreeMobilePhoneCenterY = ( isWideMobile ? -50: -150);


export const targetDualPedigreeChartScale        = 1.75;
export const targetDualPedigreeChartIpadScale    = 1.3;
export const targetDualPedigreeChartAndroidTabletScale    = 1;

export const targetPedigreeChartScale        = 1.75;
export const targetDualPedigreePosX              = 125;
export const targetDualPedigreePosY              = 30;

export const targetFocusDesktopScale             = 2.3;
export const exitMobileFlipCardScale             = 2.3;
export const midscale                            = 2.3;
export const zoomedAlltheWayOutForMobileScale    = 1.6;
export const scaleWhenImageShowsForDesktop       = .1;
export const scaleWhenImageShowsForMobile        = .1;
export const speedOfLeftRightScroll              = 88;
export const viewportPulse                       = 1200;

export const constraints = { //https://validatejs.org/
  email: {
    email: {
      message: "is not a valid format."
    } ,
    length: {
      minimum: 5,
      message: "must be at least 5 characters"
    }
  }
};

/*
 *
 *
 * System paths
 *
 *
 */

export const htmlTag = document.getElementsByTagName("HTML")[0];
//export const isRTL   = htmlTag.getAttribute('dir') === 'rtl';

export const userIsLoggedIn = (isDevelopment || (typeof(window.Geni) !== 'undefined' && parseInt(window.Geni.User.id, 10) > -1) ? true: false );
//export const isSafari = /constructor/i.test(window.HTMLElement); // https://stackoverflow.com/questions/42810720/detect-safari-browser-in-javascript
// export const isSafari  = !navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (window.safari !== undefined)

// export const isPortrait = (window.innerHeight > window.innerWidth ? true: false);
export const isLandscape = (window.innerHeight < window.innerWidth ? true: false);

export const imageBasePath = '/canvas-tree/imgs/';

export const getTranslatedLabels = () => {
  return translateLabels()
}

export const translatedLabels = getTranslatedLabels();


